export default "__VITE_ASSET__BcNeT4sm__"